import '@/shared/plugins/element';
import Vue from 'vue';
import Vuex from 'vuex';
import Router from 'vue-router';
import {
  setupComponentsFiltersDirectivesAndMixins,
  storeAsync,
  routerAsync,
} from '@/app-module';
import app from '@/app.vue';

import Quasar from 'quasar';
import { Notify } from 'quasar';
import { Meta } from 'quasar';

Vue.use(Quasar, {
  plugins: {
    Notify,
    Meta,
  },
  config: {
    notify: {
      /* Notify defaults */
    },
  },
});


import langAr from 'quasar/lang/ar';
Vue.use(Quasar, {
  // ...,
  lang: langAr,
});
// new features
// import router from "./modules/layout/router/index";
import { LoadingBar } from 'quasar';
LoadingBar.setDefaults({
  color: 'amber-14',
  size: '1px',
  position: 'top',
});

// import BlackDashboard from "./plugins/blackDashboard";
// import * as VueGoogleMaps from 'vue2-google-maps';
import BootstrapVue from 'bootstrap-vue';
import VuePageTransition from 'vue-page-transition';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';

// import { SettingsService } from '@/modules/settings/settings-service';
// import ProgressBar from '@/shared/progress-bar/progress-bar';
// import { i18n } from '@/i18n';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import vueSmoothScroll from 'vue2-smooth-scroll';

import './quasar';
// import QImg from 'quasar'

// Custom Styles
import './scss/index.scss'

import VueMeta from 'vue-meta'
import VueHead from 'vue-head'
// import i18n from './i18n'
import i18n from './vueI18n'

(async function() {
  // document.title = i18n('app.title');
  // ProgressBar.start();
  // SettingsService.fetchAndApply();
  // routerAsync().push('/auth/signin');

  // ============================================================================= //
  Vue.use(VueMeta, {
    // optional pluginOptions
    refreshOnceOnNavigation: true
  })
  Vue.use(VueHead)
  
  Vue.use(PerfectScrollbar);
  Vue.component('font-awesome-icon', FontAwesomeIcon);
  Vue.component(
    'vue-phone-number-input',
    VuePhoneNumberInput,
  );

  Vue.use(VuePageTransition);
  Vue.use(BootstrapVue);
  // Vue.use(VueGoogleMaps, {
  //   load: {
  //     key: 'AIzaSyAP6KUv6fM-DyHHSVedSYpKsKnX5PUT_Z8',
  //     libraries: 'places', // necessary for places input
  //   },
  // });
  // Vue.use(BlackDashboard);
  Vue.use(vueSmoothScroll);
  Vue.directive('title', {
    inserted: (el, binding) =>
      (document.title = binding.value),
    update: (el, binding) =>
      (document.title = binding.value),
  });
  // ============================================================================= //

  Vue.use(Router);
  Vue.use(Vuex);
  setupComponentsFiltersDirectivesAndMixins();

  // eslint-disable-next-line
  new Vue({
    store: storeAsync(),
    router: routerAsync(),
    i18n,
    render: (h) => h(app)
  }).$mount('#app');
})();

// export default function(Vue, { head }) {
//   head.meta.push({
//     key: 'og:description',
//     // name: 'og:description',
//     property: 'og:description',
//     content: `Tim Deschryver's experiences and thoughts on programming`,
//   })

//   head.meta.push({
//     key: 'twitter:description',
//     // name: 'twitter:description',
//     property: 'twitter:description',
//     content: `Tim Deschryver's experiences and thoughts on programming`,
//   })
// }